import {Component} from '@angular/core';
import {DxTabsComponent} from 'devextreme-angular';
import {FileImportByHourComponent} from "./by-hour/file-import-by-hour.component";
import {FileImportListComponent} from "./list/file-import-list.component";

type TabKey = 'by hour' | 'list';

interface Tab {
    key: TabKey,
    text: string,
    icon: string
}

@Component({
    selector: 'app-file-import',
    templateUrl: './file-import.component.html',
    styleUrls: ['./file-import.component.scss'],
    imports: [
        DxTabsComponent,
        FileImportByHourComponent,
        FileImportListComponent,
    ]
})
export class FileImportComponent {
    tabs: Tab[] = [
        {key: 'by hour', text: 'Table View', icon: 'fas fa-table'},
        {key: 'list', text: 'List View', icon: 'fas fa-list'}
    ];

    selectedTab: TabKey = 'by hour';
}
